import {
  deriveBillingCycleIntervalFromStripeSubscriptions,
  deriveCurrentPlanIdFromStripeSubscriptions,
  isActiveStripeSubscriptionStatus,
  type StripeSubscriptionStateLike,
} from "@reelmagic/domain";

type SubscriptionRecord = Omit<StripeSubscriptionStateLike, "created" | "current_period_start"> & {
  created?: unknown;
  current_period_start?: unknown;
};

function timestampString(value: unknown): string | null {
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && "toDate" in value && typeof value.toDate === "function") {
    return (value.toDate() as Date).toISOString();
  }
  return null;
}

export function getBillingPlanSummary(records: readonly SubscriptionRecord[]) {
  const subscriptions = records.map((subscription) => ({
    ...subscription,
    created: timestampString(subscription.created),
    current_period_start: timestampString(subscription.current_period_start),
  }));
  const planId = deriveCurrentPlanIdFromStripeSubscriptions(subscriptions);
  return {
    planId,
    hasPaidPlan: planId !== "free",
    hasActiveSubscription: subscriptions.some((subscription) => isActiveStripeSubscriptionStatus(subscription.status)),
    billingInterval: deriveBillingCycleIntervalFromStripeSubscriptions(subscriptions),
  };
}
